module["exports"] = [
  "Türkiye"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/tr/address/default_country.js
// module id = 1161
// module chunks = 0